import { RSP_CONTRACT_ABI, RSP_CONTRACT_ADDRESS } from '../constants/contract';
import { ContractFunctionNames } from '../constants/types';
import { PublicClient } from 'viem';

import { RoomInfo } from 'shared/types/app-types';

const readContractCall = async <T>(
  provider: PublicClient,
  functionName: ContractFunctionNames,
  args: Parameters<typeof provider.readContract>[0]['args'] = [],
  signal?: AbortSignal,
): Promise<T> => {
  try {
    if (signal?.aborted) throw new DOMException('Aborted', 'AbortError');

    const result = await provider.readContract({
      address: RSP_CONTRACT_ADDRESS,
      abi: RSP_CONTRACT_ABI,
      functionName,
      args,
      authorizationList: undefined,
    });

    if (signal?.aborted) throw new DOMException('Aborted', 'AbortError');

    return result as T;
  } catch (error) {
    if ((error as DOMException).name === 'AbortError') {
      console.log(error);
      console.warn(`Aborted: ${functionName}`);
      return;
    }

    console.error(`Error reading ${functionName}:`, error);
    throw new Error(`Failed to read ${functionName}`);
  }
};

export const readRoomIdCounter = (provider: PublicClient, signal?: AbortSignal) =>
  readContractCall<bigint>(provider, ContractFunctionNames.ROOM_ID_COUNTER, [], signal);

export const readActiveRoomCounter = (provider: PublicClient, signal?: AbortSignal) =>
  readContractCall<bigint>(provider, ContractFunctionNames.ACTIVE_ROOM_COUNTER, [], signal);

export const readGetRoomsInfo = (
  provider: PublicClient,
  from: number,
  to: number,
  signal?: AbortSignal,
) =>
  readContractCall<RoomInfo[]>(provider, ContractFunctionNames.GET_ROOMS_INFO, [from, to], signal);
